// extracted by mini-css-extract-plugin
export default {"Payment":"Payment_Payment__Lyc++","container":"Payment_container__F2D8-","mixplatForm":"Payment_mixplatForm__LWc3x","close":"Payment_close__u+imd"};